@if (dataContext) {
  <form class="action-form" [formGroup]="form">
    <span class="title">{{ 'HOGIA.CONNECTED' | translate }}</span>
    <div class="form-group">
      {{ 'HOGIA.CONNECT_REDIRECT_INFO' | translate }}
    </div>
    <div class="row form-group">
      <span class="error">{{ errorMessage }}</span>
    </div>
    <div>
      @if (hogiaOBUrl) {
        <a class="btn btn-active" (click)="redirect()" [href]="hogiaOBUrl" target="_blank">{{ 'OK_BTN' | translate }}</a>
      }
      <button class="btn link-btn ml-2" (click)="close()">{{ 'CANCEL_BTN' | translate }}</button>
    </div>
  </form>
}
